const VALID_LETTERS =
  /^[a-záéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ][a-z\\'áéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ\s-]+$/gi

const isFullname = (name, nameCount = 0) => {
  if (!name) name = ""
  let hasSingleChars = false

  const nameWithoutSpaces = name.trim()
  const splitedFullname = nameWithoutSpaces.split(/\s+/)

  const validSingleChairs = {
    e: true,
    E: true,
  }

  const fullNameWithoutSingleChars = splitedFullname
    .reduce((acc, value, index, arr) => {
      if (value.length === 1 && !validSingleChairs[value]) hasSingleChars = true
      if (index === 0 || index === arr.length - 1 || value.length > 1) {
        acc.push(value)
      }
      return acc
    }, [])
    .join(" ")

  const hasNameLimitation = nameCount
    ? splitedFullname.length === nameCount
    : splitedFullname.length > 1

  const isAllLettersValid = !!fullNameWithoutSingleChars.match(VALID_LETTERS)

  const isValidFullName =
    hasNameLimitation &&
    isAllLettersValid &&
    !hasSingleChars

  return isValidFullName
}

const hasTitleName = (name) => {
  if (!name) name = ""
  return name.match(/^(dr |dra |sr |sra |eng )/)
}

export { isFullname, hasTitleName }